var _circle, _circle2, _circle3, _circle4, _circle5, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 136,
    viewBox: "0 0 184 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 64,
    r: 64,
    fill: "#EAECF0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 12,
    r: 6,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 112,
    r: 8,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 96,
    r: 8,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 157,
    cy: 9,
    r: 5,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_145_9261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9372 95.3137L92.8147 76.7185C94.8169 75.7848 95.6831 73.4049 94.7495 71.4028L71.1994 20.8995L55.2523 15.0953L22.6252 30.3095C20.6231 31.2431 19.7569 33.6231 20.6905 35.6252L47.6215 93.3789C48.5551 95.3811 50.935 96.2473 52.9372 95.3137Z",
    fill: "url(#paint0_linear_145_9261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2522 15.0953L71.1993 20.8996L60.3236 25.971L55.2522 15.0953Z",
    fill: "#D0D5DD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_145_9261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 81.7241H116C118.209 81.7241 120 79.9333 120 77.7241V22L108 10H72C69.7909 10 68 11.7909 68 14V77.7241C68 79.9333 69.7909 81.7241 72 81.7241Z",
    fill: "url(#paint1_linear_145_9261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 10L120 22H108V10Z",
    fill: "#D0D5DD"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_145_9261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.6253 76.6946L134.503 95.2898C136.505 96.2234 138.885 95.3572 139.819 93.3551L163.369 42.8518L157.564 26.9047L124.937 11.6905C122.935 10.7569 120.555 11.6231 119.622 13.6252L92.6906 71.3789C91.7569 73.3811 92.6232 75.761 94.6253 76.6946Z",
    fill: "url(#paint2_linear_145_9261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.564 26.9047L163.368 42.8518L152.493 37.7804L157.564 26.9047Z",
    fill: "#D0D5DD"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_145_9261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 68,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#344054",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3333 100.667L93.9999 96M93.9999 96L98.6666 100.667M93.9999 96V106.5M103.333 101.533C104.758 100.356 105.667 98.5759 105.667 96.5833C105.667 93.0395 102.794 90.1667 99.2499 90.1667C98.995 90.1667 98.7565 90.0337 98.6271 89.814C97.1057 87.2323 94.2968 85.5 91.0833 85.5C86.2508 85.5 82.3333 89.4175 82.3333 94.25C82.3333 96.6605 83.3079 98.8433 84.8847 100.426",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_145_9261",
    x: -1,
    y: 10.0239,
    width: 117.44,
    height: 126.98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_145_9261"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_145_9261"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_145_9261"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_145_9261",
    result: "effect2_dropShadow_145_9261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_145_9261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_145_9261",
    x: 48,
    y: 10,
    width: 92,
    height: 111.724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_145_9261"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_145_9261"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_145_9261"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_145_9261",
    result: "effect2_dropShadow_145_9261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_145_9261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_145_9261",
    x: 71,
    y: 10,
    width: 117.44,
    height: 126.98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_145_9261"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_145_9261"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_145_9261"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_145_9261",
    result: "effect2_dropShadow_145_9261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_145_9261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_145_9261",
    x: 58,
    y: 60,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_145_9261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_145_9261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_145_9261",
    x1: 50.5944,
    y1: 95.4694,
    x2: 18.8151,
    y2: 38.1371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_145_9261",
    x1: 69.8109,
    y1: 80.8751,
    x2: 65.2388,
    y2: 15.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_145_9261",
    x1: 93.0001,
    y1: 75,
    x2: 116.492,
    y2: 13.8032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FAFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/noResults.0fb0ebcad368cdfd29be71e877753ff6.svg";
export { ForwardRef as ReactComponent };